import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Header from 'components/Header';
import ScrollTop from './ScrollTop';
import Footer from 'components/Footer';
import Loader from 'components/Loader';
import GeneralContent from 'components/GeneralContent';
import {routes, Error404} from './routes';
import {urlPath} from 'config';

const Routes = () => {
    const withHeaderFooter = window && (window.location.pathname.indexOf('/_secure/cart') === -1 && window.location.pathname.indexOf('/checkout') === -1 && window.location.pathname.indexOf('/login-page') === -1 );

    return (
        <Router basename={urlPath}>
            <ScrollTop>
                {withHeaderFooter && <Header/>}
                <GeneralContent/>
                <Suspense fallback={<Loader />}>
                    <Switch>
                        {routes.map((route, i)=>
                            <Route
                                exact
                                key={i}
                                path={route.path}
                                component={route.component}
                            />)}
                        {<Route render={props => (<Error404  {...props}/>)} />}
                    </Switch>
                </Suspense>
                {withHeaderFooter && <Footer />}
            </ScrollTop>
        </Router>
    )
}

export default Routes;
